import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { TimePeriodSelector } from "./TimePeriodSelector";
import { nanoid } from "@reduxjs/toolkit";
import { lastToNextDateFunction } from "../../../../utils/relativeDates/lastToNextDateFunction";
import { thisToThisDateFunction } from "../../../../utils/relativeDates/thisToThisDateFunction";
import { breakValue } from "../../../../../smallFunction/SmallFunctions";

const rightSideOptions = [
  { value: "Days" },
  { value: "Weeks" },
  { value: "Months" },
  { value: "Quarters" },
  { value: "Years" },
];

export default function DataConfigComp({
  droppedItem,
  handleClosePopup,
  handleSavePopupFilter,
}) {
  console.log(droppedItem);
  const result =
    droppedItem !== undefined && droppedItem.relativeDateIs !== undefined
      ? breakValue(droppedItem.relativeDateIs, "dateConfigComp")
      : null;
  let { period, value, unit } =
    result !== undefined && result !== null && result;
  console.log({ period, value, unit });
  console.log(period || 1);
  const requiredPeriod =
    period === undefined || period === null
      ? 1
      : period === "Last"
      ? 3
      : period === "Next"
      ? 4
      : period;
  const [alreadyExists, setAlreadyExists] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(rightSideOptions[2].value);
  const [selectedOption, setSelectedOption] = useState(requiredPeriod);
  const [lastValue, setLastValue] = useState(5);
  const [nextValue, setNextValue] = useState(5);
  const [previewSectionValue, setPreviewSectionValue] = useState(null);
  console.log(selectedUnit);
  console.log(selectedOption);
  console.log(previewSectionValue);
  useEffect(() => {
    if (droppedItem.dateUnit) {
      setSelectedUnit(droppedItem.dateUnit);
    }
  }, [droppedItem.dateUnit]);
  useEffect(() => {
    if (
      droppedItem.isRelativeDate &&
      droppedItem.relativeDateIs &&
      droppedItem.dateUnit
    ) {
      setAlreadyExists(true);
    }
  }, [droppedItem]);
  const handleSave = () => {
    console.log(selectedUnit);
    console.log(selectedOption);

    if (lastValue) {
      const numericLastValue = Number(lastValue);
      console.log(numericLastValue);
    }

    if (nextValue) {
      const numericNextValue = Number(nextValue);
      console.log(numericNextValue);
    }
  };
  const Option = (selectedOption, selectedUnit, lastValue, nextValue) => {
    if (selectedOption === 0) {
      switch (selectedUnit) {
        case "Days":
          return "Yesterday";
        case "Weeks":
          return "Last Week";
        case "Months":
          return "Last Month";
        case "Quarters":
          return "Last Quarter";
        case "Years":
          return "Last Year";
        default:
          return ""; // Default case if none match
      }
    } else if (selectedOption === 1) {
      switch (selectedUnit) {
        case "Days":
          return "Today";
        case "Weeks":
          return "This Week";
        case "Months":
          return "This Month";
        case "Quarters":
          return "This Quarter";
        case "Years":
          return "This Year";
        default:
          return ""; // Default case if none match
      }
    } else if (selectedOption === 2) {
      switch (selectedUnit) {
        case "Days":
          return "Tomorrow";
        case "Weeks":
          return "Next Week";
        case "Months":
          return "Next Month";
        case "Quarters":
          return "Next Quarter";
        case "Years":
          return "Next Year";
        default:
          return ""; // Default case if none match
      }
    } else if (selectedOption === 3) {
      switch (selectedUnit) {
        case "Days":
          return `Last ${lastValue} Days`;
        case "Weeks":
          return `Last ${lastValue} Weeks`;
        case "Months":
          return `Last ${lastValue} Months`;
        case "Quarters":
          return `Last ${lastValue} Quarters`;
        case "Years":
          return `Last ${lastValue} Years`;
        default:
          return ""; // Default case if none match
      }
    } else if (selectedOption === 4) {
      switch (selectedUnit) {
        case "Days":
          return `Next ${nextValue} Days`;
        case "Weeks":
          return `Next ${nextValue} Weeks`;
        case "Months":
          return `Next ${nextValue} Months`;
        case "Quarters":
          return `Next ${nextValue} Quarters`;
        case "Years":
          return `Next ${nextValue} Years`;
        default:
          return ""; // Default case if none match
      }
    } else if (selectedOption === 5) {
      switch (selectedUnit) {
        case "Days":
          return "Day to Day";
        case "Weeks":
          return "Week to Week";
        case "Months":
          return "Month to Month";
        case "Quarters":
          return "Quarter to Quarter";
        case "Years":
          return "Year to Year";
        default:
          return ""; // Default case if none match
      }
    }
    return "";
  };
  const relativeDateIs = Option(
    selectedOption,
    selectedUnit,
    lastValue,
    nextValue
  );
  console.log(relativeDateIs);
  useEffect(() => {
    console.log(relativeDateIs);
    if (relativeDateIs !== "") {
      const localResult = breakValue(relativeDateIs, "buildQuery");
      console.log(localResult);
      if (localResult) {
        const { period, value, unit } = localResult;
        console.log(period, value, unit);
        const { minValue, maxValue } = lastToNextDateFunction({
          period,
          value,
          unit,
        });
        console.log(minValue, maxValue);
        setPreviewSectionValue({ fromDateTo: minValue, toThisDate: maxValue });
      } else {
        const { minValue, maxValue } = thisToThisDateFunction(
          relativeDateIs,
          selectedUnit
        );
        console.log(minValue, maxValue);
        setPreviewSectionValue({ fromDateTo: minValue, toThisDate: maxValue });
      }
    }
  }, [relativeDateIs]);
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleSavePopupFilter(
        {
          ...droppedItem,
          isRelativeDate: true,
          relativeDateIs,
          dateUnit: selectedUnit,
          selectedOperator: "BETWEEN",
          visibleFilter: true,
          filterComponentType: "relativeDate",
        },
        alreadyExists
      );
      handleClosePopup();
      handleSave();
    }
  };

  return (
    <main
      className="fixed inset-0 bg-gray-600 bg-opacity-50 flex flex-col items-center justify-center z-40"
      onKeyDown={handleKeyDown}
    >
      <main className="w-[28rem] h-[22rem] bg-white flex flex-col items-start justify-start gap-1 rounded">
        <section className="flex justify-between items-center p-1 w-full h-[10%] font-medium bg-gray-50">
          Relative Date [{droppedItem.columnName}]
          <RxCross2 className="cursor-pointer" onClick={handleClosePopup} />
        </section>
        {TimePeriodSelector({
          selectedUnit,
          selectedOption,
          setSelectedOption,
          lastValue,
          setLastValue,
          nextValue,
          setNextValue,
          rightSideOptions,
          setSelectedUnit,
          visibleInAside3SideBar: false,
        })}
        {previewSectionValue !== null ? (
          <section className="w-full p-1 h-[10%] flex items-center justify-center gap-2">
            <button>{previewSectionValue.fromDateTo}</button>-
            <button>{previewSectionValue.toThisDate}</button>
          </section>
        ) : null}
        <section className="flex justify-end gap-4 items-center p-1 w-full h-[15%] bg-gray-50">
          <button
            onClick={handleClosePopup}
            className="border border-gray-200 px-3 py-1"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              handleSavePopupFilter(
                {
                  ...droppedItem,
                  isRelativeDate: true,
                  relativeDateIs,
                  dateUnit: selectedUnit,
                  selectedOperator: "BETWEEN",
                  visibleFilter: true,
                  filterComponentType: "relativeDate",
                  nanoId: droppedItem.nanoId || nanoid(),
                },
                alreadyExists
              );
              handleClosePopup();
              handleSave();
            }}
            disabled={relativeDateIs === ""}
            className={`border px-4 py-1 border-blue-950 ${
              relativeDateIs === " "
                ? "bg-gray-400 text-white"
                : " bg-blue-950 text-white"
            } `}
          >
            Save
          </button>
        </section>
      </main>
    </main>
  );
}
